import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { Role } from '@/core/api/entities/role/role'
import { RoleMapper } from '@/core/api/mappers/role/roleMapper'
import { roleService } from '@/core/api/services/roleService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

/**
 * Get all roles
 */
export const useRoles = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<Role[], Error> => {
	const QUERY_KEY = ['roles', 'all']

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			roleService.getAllRoles(config).then(({ data: response }) => {
				return RoleMapper.toEntities(response?.data || [])
			}),
		...options,
		staleTime: 5 * 60 * 1000, // 5 minutes
		gcTime: 10 * 60 * 1000, // 10 minutes
	})
}
